import React from 'react'
import { Row } from 'antd'
import CRUDComponent from '../../../../component/common/CRUD-Component'
import CONSTANTS from '../../../../util/constant/CONSTANTS'
import { COPY_UNIQUE_ID, convertUTCToLocal } from '../../../../util/functions'
import Heading from '../../../../component/common/Heading'

const DeviceErrorLogs = ({ deviceId }) => {
    return (
        <>
            <div>
                <Heading>Device Error Logs</Heading>
                <Row>
                    <CRUDComponent
                        GET={{
                            API: CONSTANTS.API.Device_Error.getAll,
                            extraQuery: {
                                deviceId
                            },
                            DataModifier: (res, API, Setrefresh) => {
                                // console.log(res, "GET ALL ABCD");
                                return res?.map(data => {
                                    return {
                                        ...data,
                                        no: `DE${data?.id.toString().padStart(7, "0")}`,
                                        timeStampD: data?.timeStamp ? convertUTCToLocal(data?.timeStamp, 'DD MMM, YYYY hh:mm A') : '',
                                        uniqueIdD: COPY_UNIQUE_ID(data?.device?.uniqueId) || '-',

                                    }
                                })
                            },
                            column: CONSTANTS.TABLE.PET_DEVICE_ERROR_LOG,
                        }}
                        UPDATE={{
                            API: CONSTANTS.API.Device_Error.update,
                            message: "Updated Remark successfully",
                            modaltitle: "Update Remark",
                            modalFields: CONSTANTS.FORM_FIELD.ERROR_LOG_MODAL,

                        }}
                        isSearch={true}

                    />
                </Row>

            </div>
        </>
    )
}

export default DeviceErrorLogs